import React from "react";
import { HiPencilSquare, HiTrash } from "react-icons/hi2";

const iconByType = {
  edit: HiPencilSquare,
  delete: HiTrash,
};

export default function SystemSettingsActionButton({
  type = "edit",
  onClick,
  title,
  disabled = false,
  className = "",
}) {
  const Icon = iconByType[type] || HiPencilSquare;
  const classes = [
    "system-settings-action-button",
    `system-settings-action-button--${type}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      title={title}
      aria-label={title}
      disabled={disabled}
    >
      <Icon className="system-settings-action-button__icon" aria-hidden="true" />
    </button>
  );
}
